export default function getNotificationsApiUrl() {
  const environment = process.env.GOVLAUNCH_ENV || process.env.NODE_ENV || "development";

  if (environment === "test") {
    return "http://localhost:4001";
  }

  return process.env.NOTIFICATIONS_API_URL;
}
